import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer'
import Logo from '../../assets/images/brand/login_logo.png';
import Stamp from '../../assets/images/brand/star-stamp.png';

const formatDateWithSuperscript = (dateString) => {
    if (!dateString) return '';

    const parts = dateString.split(' ');

    if (parts.length < 3) return dateString;

    let day = parts[0].match(/\d+/)[0];
    const suffix = parts[0].replace(/\d+/, '');
    const month = parts[1];
    const year = parts[2];

    day = day.padStart(2, '0');

    return { day, suffix, month, year };
};

const Certificate = ({ data }) => {
    const formattedDate = formatDateWithSuperscript(data[0]?.completion_date);
    const formattedCertificateDate = formatDateWithSuperscript(data[0]?.certificate_date);

    Font.register({
        family: 'Open Sans',
        src: require('../../assets/fonts/OpenSans-Regular.ttf') // Adjust the path
    });
    Font.register({
        family: 'Open Sans Bold',
        src: require('../../assets/fonts/OpenSans-SemiBold.ttf') // Adjust the path
    });

    // Styles
    const styles = StyleSheet.create({
        page: {
            fontFamily: 'Open Sans',
        },
        body: {
            paddingTop: 55,
            paddingBottom: 25,
            paddingHorizontal: 10,
        },
        text: {
            fontFamily: 'Open Sans',
            fontSize: 16,
            textAlign: 'justify',
            fontWeight: 100,
            marginBottom: 30,
        },
        stuName: {
            fontFamily: 'Open Sans Bold',
            fontSize: 20,
            textAlign: 'justify',
            marginBottom: 30,
        },
        degreeText: {
            fontFamily: 'Open Sans Bold',
            fontSize: 20,
            textAlign: 'justify',
            marginTop: 30,
            marginBottom: 30,
        },
        textSentence: {
            fontFamily: 'Open Sans',
            fontSize: 16,
            textAlign: 'justify',
            fontWeight: 100,
            marginBottom: 7,
        },
        detailsText: {
            fontFamily: 'Open Sans',
            fontSize: 8,
            textAlign: 'justify',
            fontWeight: 600,
            marginBottom: 2,
        },
        signatureText: {
            fontFamily: 'Open Sans',
            fontSize: 15,
            textAlign: 'justify',
            fontWeight: 200,
            marginTop: 30,
            marginBottom: 20,
        },
        signatureTextBottom: {
            fontFamily: 'Open Sans',
            fontSize: 15,
            textAlign: 'justify',
            fontWeight: 200,
            marginTop: 50,
        },
        scanText: {
            fontSize: 5,
            textAlign: 'justify',
            fontWeight: 100,
            marginBottom: 20,
        },
        superscript: {
            fontSize: 10,
            verticalAlign: 'super',
        },
        image: {
            width: 112
        },
        logoSec: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 35,
        },
        approveSec: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 10
        },
        leftSec: {
            flex: 1,
            alignItems: "center",
        },
        stampSec: {
            flex: 1,
            alignItems: "center",
        },
        stampImage: {
            width: 195,
        },
        rightSec: {
            flex: 1,
            alignItems: "center",
        },
        qrImage: {
            marginTop: 15,
            width: 70,
            height: 70,
        },
        bodySec: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            marginVertical: 10,
        },
    });

    // if (!qrCodeDataUri) return <Text>Loading certificate...</Text>


    return (
        <Document>
            <Page size="A4" style={styles.body}>
                {/* Logo Section */}
                <View style={styles.logoSec}>
                    <Image style={styles.image} src={Logo} />
                </View>

                {/* Certificate Text */}
                <View style={styles.bodySec}>
                    <Text style={styles.text}>This is to certify that</Text>
                    <Text style={styles.stuName}>{data[0]?.student_name}</Text>
                    <Text style={styles.textSentence}>
                        having fulfilled the conditions prescribed by the
                    </Text>
                    <Text style={styles.textSentence}>
                        University is this day admitted to
                    </Text>
                    <Text style={styles.degreeText}>{data[0]?.course.name}</Text>
                    <Text style={styles.textSentence}>Given under the common seal of IBSUniversity</Text>
                    <Text style={styles.textSentence}>on {formattedCertificateDate.day}<Text style={styles.superscript}>{formattedCertificateDate.suffix}</Text> {formattedCertificateDate.month} {formattedCertificateDate.year}
                    </Text>
                    {/* <Text style={styles.textSentence}>on 23<Text style={styles.superscript}>rd</Text> April 2024</Text> */}
                </View>

                {/* Approval Section with Three Columns */}
                <View style={styles.approveSec}>
                    {/* Left Section */}
                    <View style={styles.leftSec}>
                        <Text style={styles.signatureText}>VICE-CHANCELLOR</Text>
                        <Text style={styles.signatureTextBottom}>CHANCELLOR</Text>
                    </View>

                    {/* Middle Section (Stamp) */}
                    <View style={styles.stampSec}>
                        <Image style={styles.stampImage} src={Stamp} />
                    </View>
                    {/* Right Section (QR Code & Text) */}
                    <View style={styles.rightSec}>
                        <Image style={styles.qrImage} src={data[1]} />
                        <Text style={styles.scanText}>Scan to verify certificate.</Text>
                        <Text style={styles.detailsText}>Document Ref.: {data[0]?.document_ref}</Text>
                        <Text style={styles.detailsText}>Completion Date: {formattedDate.day} {formattedDate.month} {formattedDate.year}</Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
}

export default Certificate;